import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Handshake } from "lucide-react";
import UnderConstruction from "@/components/common/UnderConstruction";

export const Route = createFileRoute("/_app/ventes/crm/")({
  staticData: {
    title: "CRM",
    icon: Handshake,
    tab_icon: Handshake,
    permission: PERMISSIONS.VENTES.CRM.VIEW,
    module: "ventes",
    order: 70,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion du CRM",
  },
  component: UnderConstruction,
});
